// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"Registration_progressBarWrapper__DNCWt"};